<template>
  <div class="app-file-picker">
    <input
      @change="onFileSelect"
      ref="fileInput"
      type="file"
      style="display: none;"
    />
    <label class="label">
      {{ label }}
      <span v-if="isRequired">*</span>
    </label>
    <div class="input-content">
      <div class="value">
        <span>{{
          fileName && fileName.length > 30
            ? fileName.slice(0, 30) + '...'
            : fileName
        }}</span>
        <button
          @click="deleteFile"
          v-if="fileName"
          type="button"
          class="remove-btn"
        >
          <b-icon size="is-small" icon="close"></b-icon>
        </button>
      </div>
      <button @click="onClick" type="button">
        <b-icon size="is-small" icon="upload"></b-icon>
        <span>Selecionar</span>
      </button>
    </div>
  </div>
</template>

<script>
import FileMixin from '@/mixins/FileMixin';

export default {
  name: 'app-file-picker',
  mixins: [FileMixin],
  model: {
    prop: 'model',
    event: 'input',
  },
  props: ['label', 'model', 'type', 'required', 'disabled'],
  data: () => {
    return {
      fileName: null,
      fileUrl: null,
    };
  },
  methods: {
    onClick() {
      !this.disabled && this.$refs.fileInput.click();
    },
    async onFileSelect(event) {
      const [file] = event.target.files;
      const url = await this.fileToBase64(file);
      this.$refs.fileInput.value = null;

      this.fileName = file.name;
      this.updateModel(url);
    },
    deleteFile() {
      this.fileName = null;
      this.updateModel(null);
    },
    updateModel(value) {
      this.$emit('input', value);
    },
  },
  computed: {
    isRequired() {
      return this.required === '' || this.required;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-file-picker {
  margin: 12px 0;

  label {
    display: block;
    text-transform: uppercase;
    font-size: 0.9em;
    margin-bottom: 0.5em;
    font-weight: 400;

    > span {
      color: var(--color-danger);
      font-size: 0.9em;
      position: relative;
      top: -3px;
      left: -2px;
    }
  }

  .input-content {
    display: flex;
    align-content: center;

    .value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 0 75%;
      border: 1px solid #ddd;
      outline: 0;
      padding: 8px;
      border-radius: 4px 0 0 4px;
      height: 38px;
      font-size: 1em;
      color: #424242;

      .remove-btn {
        border: none;
        background: transparent;
        color: var(--color-danger);
        outline: 0;
        font-size: 1.1em;
        font-weight: bold;
        cursor: pointer;
        transition: background 0.2s ease-in-out;

        &:hover {
          background: rgba(0, 0, 0, 0.04);
        }
      }
    }

    button:not(.remove-btn) {
      flex: 0 25%;
      border: none;
      background: var(--color-primary);
      color: #fff;
      border-radius: 0 8px 8px 0;
      outline: 0;
      cursor: pointer;
      transition: background 0.2s ease-in-out;

      &:hover {
        background: var(--color-primary-shade);
      }

      .icon {
        font-size: 1.4em;
        margin-right: 4px;
      }
    }
  }
}
</style>
